export default __webpack_public_path__ + "static/media/WarningIcon.8310acd1.svg";